





























































import { defineComponent } from '@nuxtjs/composition-api';
import { IBlokSingleImage } from '~/components/storyblok/SingleImage.vue';
import type { PropType } from '@nuxtjs/composition-api';
import { SfButton } from '~/components/StorefrontUi';

interface Blok {
  _uid: string;
  title: string;
  description?: string;
  price_text?: string;
  mainTag?: string;
  secondaryTag?: string;
  image?: IBlokSingleImage[];
  color: {
    color: string;
  };
  linkLabel?: string;
  link?: {
    cached_url: string;
    fieldtype: string;
    linktype: string;
  };

}

export default defineComponent({
  name: 'PromoProduct',
  components: {
    SfButton,
  },
  props: {
    blok: {
      type: Object as PropType<Blok>,
      required: true,
    },
  },
  setup({ blok }: { blok: Blok }) {
    const color = blok.color.color || '#8B154E';
    return {
      color,
    };
  },
});
